import {
  ApplicationView,
  StartControllerScope,
  useController,
} from '@aha-app/mvc';
import React, { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import styles from './AiTemplatesModal.module.css';
import AiTemplatesController from './AiTemplateController';
import AiTemplatePicker from './AiTemplatePicker';
import DetailTemplateModal from './DetailTemplateModal';

function AiTemplatesModal() {
  const controller = useController(AiTemplatesController);
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (modalRef.current) {
      modalRef.current.showPopover();
    }
  }, []);

  const { currentTemplate, loading } = controller.state;
  let body;
  if (loading) {
    body = null;
  } else if (currentTemplate) {
    body = <DetailTemplateModal template={currentTemplate} />;
  } else {
    body = <AiTemplatePicker />;
  }

  return ReactDOM.createPortal(
    <div ref={modalRef} className={styles.modal} popover='manual'>
      <div className={styles.container}>
        {loading && (
          <div className={styles.loader}>
            <aha-spinner size='45px' opacity={1} />
          </div>
        )}
        {!loading && (
          <aha-modal-body style={{ overflow: 'hidden' }}>{body}</aha-modal-body>
        )}
      </div>
    </div>,
    document.body
  );
}

export default StartControllerScope(
  AiTemplatesController,
  ApplicationView(AiTemplatesModal)
);
